module.exports = __webpack_public_path__ + "img/t-4.c98f1018.png";